const mistakes = [
  {
    icon: "ri-calendar-close-line",
    title: "The Snowbird Dormant Passport Trap",
    description:
      "You spent the entire summer in Venice — walking Caspersen Beach for shark teeth, cycling the Legacy Trail, attending Venice Theatre matinees, and dining on Venice Avenue. Your passport sat in a drawer the whole time, untouched since your Toronto visit last February. Now it is October, and you are booking a Caribbean cruise for January through your travel club. You pull out the passport and discover it expired in July. Six months of blissful Venice living, and your passport quietly expired while you were not looking.",
    fix: "Set a calendar reminder every September to check all family passports before booking winter travel. The dormant passport trap hits hardest in retirement communities where residents are deeply rooted in local activities.",
  },
  {
    icon: "ri-parent-line",
    title: "The Child Passport Expiration Surprise",
    description:
      "Your grandson is now 9. His passport was issued when he was 4 — which means it expired last year on his 9th birthday. You just booked his first spring break trip to Cancun through a deal you found flying out of Tampa, and the airline requires a valid passport number for every passenger at booking. Child passports are only valid for 5 years, and many grandparents and parents forget this shorter timeline until it is too late.",
    fix: "Set a reminder for every child's passport expiration 6 months before it expires. Start renewal early for family travel, especially spring break trips with non-refundable resort packages.",
  },
  {
    icon: "ri-time-line",
    title: "The Six-Month Validity Oversight",
    description:
      "Your passport expires in August, and your European river cruise is in June. You assume you are fine because it is still valid. But the Schengen Area requires three months of validity beyond your departure date. The cruise line flags it when you submit documents, and your non-refundable package — booked through the Venice travel club at a group rate — is at risk.",
    fix: "Renew if your passport expires within 6–9 months of any international trip. Group tour packages and cultural travel club bookings are typically non-refundable within 60–90 days of departure.",
  },
  {
    icon: "ri-image-line",
    title: "The Wrong Photo",
    description:
      "You took a passport photo at the pharmacy on Venice Avenue using a decorative background because it looked nice. Or your child was smiling because the photographer said \"cheese.\" Or your glasses left a shadow. The State Department rejects the photo, and your application is delayed by 2–3 weeks while you resubmit. For a theatre tour to London that cost you $3,200 through the Venice Theatre travel club, that delay means missing the group entirely.",
    fix: "Follow State Department photo guidelines exactly: white/off-white background, neutral expression, no glasses, correct size (2×2 inches). We review your photo before submission to eliminate rejections.",
  },
  {
    icon: "ri-file-damage-line",
    title: "The Damaged Passport",
    description:
      "Your passport went through a beach trip, got damp in a beach bag, or the binding came loose from years of Gulf Coast humidity in your Venice home. You think it is still usable because the data page is readable. The airline at SRQ or the cruise terminal in Tampa disagrees, and you are denied boarding.",
    fix: "Any physical damage, water damage, or unauthorized markings make a passport invalid. Replace it immediately through expedited service before any international travel.",
  },
  {
    icon: "ri-draft-line",
    title: "The Form Error",
    description:
      "You filled out the DS-11 or DS-82 form online, printed it, and signed it. But you used blue ink instead of black, signed outside the box, or left a required field blank. The acceptance clerk catches it, or worse, the State Department rejects the application after weeks of processing — right before your theatre tour or cruise departure.",
    fix: "Use black ink only, sign within the box boundaries, and double-check every field. We pre-review all forms before submission to eliminate this risk entirely.",
  },
];

export default function VeniceMistakesSection() {
  return (
    <section className="py-16 md:py-20 bg-[#F8F9FB]">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <span className="inline-block text-[#B22222] text-xs font-bold uppercase tracking-[0.15em] mb-3">
            Avoid These Mistakes
          </span>
          <h2 className="font-serif text-2xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Common Passport Mistakes Venice Travelers Make
          </h2>
          <p className="text-gray-600 text-sm md:text-base max-w-2xl mx-auto leading-relaxed">
            These are the errors we see most often from Venice travelers. Each one can cost you a cruise, a theatre tour, or weeks of stress.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          {mistakes.map((m, i) => (
            <div
              key={i}
              className="bg-white rounded-lg p-6 border border-gray-100 hover:border-[#F6C344]/50 transition-all"
            >
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 rounded-lg bg-[#B22222]/10 flex items-center justify-center shrink-0">
                  <i className={`${m.icon} text-[#B22222] text-lg`}></i>
                </div>
                <div>
                  <h3 className="font-serif text-base font-bold text-[#1A365D] mb-2">{m.title}</h3>
                  <p className="text-gray-600 text-sm leading-relaxed mb-3">{m.description}</p>
                  <div className="bg-[#F8F9FB] rounded-md p-3">
                    <p className="text-emerald-700 text-xs font-semibold mb-0.5">
                      <i className="ri-check-line mr-1"></i>How to avoid it:
                    </p>
                    <p className="text-gray-600 text-xs leading-relaxed">{m.fix}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}